// Inside the Tauri shell the OS comes from the native ODIN plugin
// (`plugin:odin|get_platform`), never from the WebView user agent.
export {
  isTauri,
  isMobile,
  isAndroid,
  isApple,
  platform,
} from '@4players/odin-plugin-tauri/platform';

export function isH3Supported(): boolean {
  return typeof WebTransport !== 'undefined';
}
